/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Divider,
  Button,
  Typography,
  Dialog,
  Backdrop,
  Card,
  Grid,
  IconButton,
} from "@material-ui/core";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import CheckCircle from "@material-ui/icons/CheckCircle";
import HighlightOff from "@material-ui/icons/HighlightOff";

import Add from "@material-ui/icons/Add";

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../tableIcons";

import Actions from "../../fluid/Actions/ActionFactory";
import AddDataDevice from "./AddDataDevice";

import { allowedByOpop } from '../Security/SecureCheck';

const styles = (theme) => ({
  backdrop: {
    zIndex: "5",
    color: "#fff",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#ff9100",
    },
  },
});

const status_items = [
  { label: "Access Details", key: "access_details" },
  { label: "Adaptor Inputs", key: "access_parameters" },
  { label: "Fields In Scope", key: "fields_in_scope" },
  // { label: "Data Markers", key: "data_markers" },
  { label: "World View Map", key: "iu_world_view" },
  { label: "Display Configured", key: "display_config" },
];

class DataDevices extends Component {
  state = {
    devices: [],
    getting_devices: false,
    adding_device: false,
    edit: false,
    data_device_step: 0,
    iu_name: null,
  };

  componentWillMount() {
    this.getDevices();
  }

  getDevices = () => {
    this.setState({ ...this.state, getting_devices: true });
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/information_unit/",
      method: "get",
      data: {},
    }).then((res) => {
      this.setState(
        { ...this.state, devices: res.data.result, getting_devices: false },
        () => console.log("Data Devices: ", this.state.devices)
      );
    });
  };

  // renderDeviseList = () => {
  //     return (
  //         <div style = {{display: 'flex', flexDirection : 'row', flexWrap : 'wrap'}}>
  //             {this.renderDevices()}
  //         </div>
  //     )
  // }

  renderDevices = () => {
    if (this.state.getting_devices === true) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
          }}
        ></div>
      );
    }
    if (this.state.devices.length === 0) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <Typography align="center" style={{ marginTop: "10%" }}>
            No Information Units in this Information Channel
          </Typography>
        </div>
      );
    }
    let devices = this.state.devices.map((device) => {
      return this.renderCard(device);
    });

    return devices;
  };

  renderStatus = (status_items, device) => {
    let list = status_items.map((item) => {
      let status;

      if (Array.isArray(device[item.key])) {
        status = true;
      } else {
        if (device[item.key] === null) {
          status = false;
        } else {
          status = true;
        }
      }

      // //for v1.9 we have decided to remove data markers when it is skipped.
      // if (status === false && item.key === "data_markers") {
      //   return null;
      // }

      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          {status === true ? (
            <CheckCircle fontSize="small" style={{ color: "#4caf50" }} />
          ) : (
            <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
          )}
          <Typography style={{ marginLeft: "10px" }} variant="body2">
            {item.label}
          </Typography>
        </div>
      );
    });

    return list;
  };

  deleteIU = (device) => {
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/information_unit/" +
        device.name,
      method: "delete",
      data: {},
    }).then((res) => {
      this.getDevices();
    });
  };

  editIU = (device) => {
    this.setState(
      { ...this.state, adding_device: true, iu_name: device.name, edit: true },
      () => console.log("Data Devices State :", this.state)
    );
  };

  renderCard = (device) => {
    return (
      <Grid item xs={2}>
        <Card elevation={4} style={{ width: "100%", padding: 0, margin: 0 }}>
          <CardHeader
            title={device.name}
            //subheader = {device.key + ' / ' + device.type}
            subheader={device.key}
            titleTypographyProps={{
              variant: "button",
            }}
            subheaderTypographyProps={{
              variant: "overline",
            }}
            action={
              <Fragment>
                <IconButton size="small" onClick={() => this.editIU(device)}>
                  <Edit fontSize = 'small'/>
                </IconButton>
                <IconButton
                  color="secondary"
                  size="small"
                  onClick={() => this.deleteIU(device)}
                >
                  <Delete fontSize = 'small'/>
                </IconButton>
              </Fragment>
            }
          />
          <CardContent>
            <Typography variant="overline">Configuration Status</Typography>
            <Divider style={{ marginBottom: "8px" }} />
            {this.renderStatus(status_items, device)}
          </CardContent>
        </Card>
      </Grid>
    );
  };

  addDevice = () => {
    this.setState({ ...this.state, adding_device: true });
  };

  handleClose = () => {
    this.getDevices();
    this.setState({ ...this.state, adding_device: false, iu_name: null });
  };

  renderDialog = () => {
    const { classes } = this.props;
    if (this.state.adding_device) {
      return (
        <Backdrop
          className={classes.backdrop}
          style={{ width: "100vw", height: "100vh" }}
          open={this.state.adding_device}
        >
          <AddDataDevice
            ic_name={this.props.ic_name}
            close={this.handleClose}
            iu_name={this.state.iu_name}
            edit={this.state.edit}
          />
        </Backdrop>
      );
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <Paper
          square
          elevation={4}
          style={{
            width: "100%",
            height: "calc(75vh - 10px)",
            padding: "8px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Typography style={{ flexGrow: 1 }} variant="h6">
              Information Units
            </Typography>
            <ThemeProvider theme={blue_theme}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                onClick={this.addDevice}
                disabled = {!allowedByOpop({
                  operation : "/sainapse/information_channel/{ic_name}/information_unit",
                  method : "POST",
                  operands : [
                    {
                      attrName: "ic_name",
                      value : this.props.ic_name
                }]
                })}
              >
                Add Information Units
              </Button>
              <Button
                style={{ marginLeft: "10px" }}
                variant="contained"
                color="primary"
                onClick={() => this.props.nextStep()}
              >
                Proceed to Finish
              </Button>
            </ThemeProvider>
          </div>
          <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
          <Grid
            style={{ height: "94%", maxHeight: "94%", overflow: "scroll" }}
            container
            xs={12}
            spacing={2}
            direction="row"
            wrap="wrap"
          >
            {this.renderDevices()}
          </Grid>
        </Paper>
        {this.renderDialog()}
      </Fragment>
    );
  }
}

export default withStyles(styles)(DataDevices);
